const WalletToggleWarning = props => (
  <div className={`ptm-cancel-box paytm-txt-center ptm-pos-a ptm-centralized ptm-body-bg`}>
    <h3 className={`ptm-body-color paytm-txt-center`}>Are you sure?</h3>
    <p className={`ptm-body-color paytm-txt-center`}>
      if you {props.wallet.isUsed ? 'uncheck' : 'check'} Paytm Balance, you will have to re-select
      the EMI tenure to proceed with payment
    </p>
    <div>
      <button className={`ptm-custom-btn`} onClick={props.toggleWallet}>
        OK
      </button>
      <button className={`ptm-custom-btn`} onClick={props.closeWalletWarning}>
        Cancel
      </button>
    </div>
  </div>
);

export default WalletToggleWarning;



// WEBPACK FOOTER //
// ./components/walletToggleWarning/index.js